module.exports = __webpack_public_path__ + "static/miracle-eyes-01-c4a9ca43412200c06bc6cb91c086a197.jpg";